module.exports = __webpack_public_path__ + "img/1440.7b77e38c.jpg";